var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10C7.88071 10 9 8.88071 9 7.5C9 6.11929 7.88071 5 6.5 5C5.11929 5 4 6.11929 4 7.5C4 8.88071 5.11929 10 6.5 10ZM6.5 8.5C7.05228 8.5 7.5 8.05228 7.5 7.5C7.5 6.94772 7.05228 6.5 6.5 6.5C5.94772 6.5 5.5 6.94772 5.5 7.5C5.5 8.05228 5.94772 8.5 6.5 8.5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8907 5.11931C20.285 5.50603 20.2911 6.13916 19.9044 6.53346L17.206 9.28478C16.8216 9.67672 16.1931 9.68548 15.7979 9.30442L15.0233 8.55748L13.7071 9.87369C13.3166 10.2642 12.6834 10.2642 12.2929 9.87369C11.9024 9.48317 11.9024 8.85 12.2929 8.45948L14.3035 6.4489C14.689 6.06338 15.3123 6.05772 15.7047 6.43616L16.4724 7.17645L18.4765 5.13304C18.8633 4.73875 19.4964 4.7326 19.8907 5.11931Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6 12.4477 5.55228 12 5 12C4.44772 12 4 12.4477 4 13V14C4 14.5523 4.44772 15 5 15C5.55228 15 6 14.5523 6 14V13Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C16.0523 12 16.5 12.4477 16.5 13V14C16.5 14.5523 16.0523 15 15.5 15C14.9477 15 14.5 14.5523 14.5 14V13C14.5 12.4477 14.9477 12 15.5 12Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C9.5 11.4477 9.05229 11 8.5 11C7.94772 11 7.5 11.4477 7.5 12V14C7.5 14.5523 7.94772 15 8.5 15C9.05229 15 9.5 14.5523 9.5 14V12Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12.5523 12 13 12.4477 13 13V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V13C11 12.4477 11.4477 12 12 12Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 10.4477 19.5523 10 19 10C18.4477 10 18 10.4477 18 11V14C18 14.5523 18.4477 15 19 15C19.5523 15 20 14.5523 20 14V11Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18H13V20H16C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20H11V18H4C2.34315 18 1 16.6569 1 15V5C1 3.34315 2.34315 2 4 2H20C21.6569 2 23 3.34315 23 5V15C23 16.6569 21.6569 18 20 18ZM3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5V15C21 15.5523 20.5523 16 20 16H4C3.44772 16 3 15.5523 3 15V5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerAnalytics);
export default __webpack_public_path__ + "static/media/computer-analytics.176ddd37e54916422b02d6a0ab41657f.svg";
export { ForwardRef as ReactComponent };